import { type FormEvent, useState } from "react";
import { createTenant, getSuperadminApi } from "@praesto/core";
import { Modal, FormField, Input, Button } from "@praesto/ui-kit";

export function CreateTenantModal(props: { onClose: () => void; onDone: () => void }) {
  const [displayName, setDisplayName] = useState("");
  const [ownerEmail, setOwnerEmail] = useState("");
  const [ownerDisplayName, setOwnerDisplayName] = useState("");
  const [billingEmail, setBillingEmail] = useState("");
  const [modules, setModules] = useState<
    ReadonlyArray<"procedure" | "shifts" | "monitoring" | "reservations" | "automation">
  >([]);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const api = getSuperadminApi();
      const tok = await api.getAuthToken();
      await createTenant(
        api.apiBase,
        {
          displayName,
          ownerEmail,
          ownerDisplayName,
          ...(billingEmail ? { billingEmail } : {}),
          ...(modules.length > 0 ? { activeModules: [...modules] } : {}),
        },
        tok,
      );
      props.onDone();
    } catch (e2) {
      setError(String(e2));
    } finally {
      setBusy(false);
    }
  }

  function toggleModule(m: "procedure" | "shifts" | "monitoring" | "reservations" | "automation") {
    setModules(modules.includes(m) ? modules.filter((x) => x !== m) : [...modules, m]);
  }

  return (
    <Modal open={true} onClose={props.onClose} title="Nuovo tenant" size="sm">
      <form onSubmit={submit} className="space-y-3">
        <FormField label="Slug tenant (lowercase, 4–20, [a-z0-9-])">
          <Input
            value={displayName}
            required
            minLength={4}
            maxLength={20}
            pattern="[a-z][a-z0-9-]+"
            placeholder="es. hotel-mare"
            onChange={(e) => setDisplayName(e.target.value)}
          />
        </FormField>
        <FormField label="Email Owner">
          <Input
            type="email"
            value={ownerEmail}
            required
            onChange={(e) => setOwnerEmail(e.target.value)}
          />
        </FormField>
        <FormField label="Nome Owner">
          <Input
            value={ownerDisplayName}
            required
            onChange={(e) => setOwnerDisplayName(e.target.value)}
          />
        </FormField>
        <FormField label="Email billing (opzionale)">
          <Input
            type="email"
            value={billingEmail}
            onChange={(e) => setBillingEmail(e.target.value)}
          />
        </FormField>
        <FormField label="Moduli attivi">
          <div className="flex gap-3 text-caption">
            {(["procedure", "shifts", "monitoring", "reservations", "automation"] as const).map(
              (m) => (
                <label key={m} className="flex items-center gap-1">
                  <input
                    type="checkbox"
                    checked={modules.includes(m)}
                    onChange={() => toggleModule(m)}
                  />
                  {m}
                </label>
              ),
            )}
          </div>
        </FormField>
        <div className="flex gap-2 justify-end">
          <Button type="button" size="sm" variant="ghost" onClick={props.onClose}>
            Annulla
          </Button>
          <Button type="submit" size="sm" variant="primary" disabled={busy}>
            {busy ? "…" : "Crea"}
          </Button>
        </div>
        {error && <p className="text-sm text-danger">{error}</p>}
      </form>
    </Modal>
  );
}
